import { render, staticRenderFns } from "./TextareaComponent.vue?vue&type=template&id=59f70c49"
import script from "./TextareaComponent.vue?vue&type=script&lang=ts"
export * from "./TextareaComponent.vue?vue&type=script&lang=ts"
import style0 from "./TextareaComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports